/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import AddTranslationPathButtonLayout from "../layout/AddTranslationPathButtonLayout";
import AutoFormDialog from "../dialogTypes/AutoFormDialog";
import getSchema from "../../lib/api/getSchema";

function AddTranslationPathButton ( props ) {

    const { t } = useTranslation();

    const { id, namespace, refresh, onSuccess, onFailure, ...others } = props;

    const [ open, setOpen ] = useState(false);
    const [ schema, setSchema ] = useState ();

    const onOpen = () => {

        setOpen ( true );

    };

    const onClose = () => {

        setOpen ( false );

    };

    const onCreateSuccess = ( msg ) => {

        if ( onSuccess ) {

            onSuccess ( msg );

        }
        
        refresh.refresh ();

    };

    useEffect ( async () => {

        let mounted = true;

        let schema = await getSchema ( "TranslationPath" );

        if ( mounted && schema ) {

            let column = {};

            column.name = "namespace";
            column.formGroup = 0;
            column.formOrder = 1;
            column.type = "text";
            column.readonly = true;     
            column.disabled = true;
            
            schema.columns.push ( column );

            setSchema ( schema );

        }

        return ( () => {
            mounted = false;
        } );

    }, [] );

    const setInitialDataCallback = ( formData ) => {
            
        if ( !formData ) {

            formData = {};
            
        }

        formData.namespaceId = namespace.namespaceId;
        formData.namespace = namespace.namespace;

    }

    return (

        <>
            <AddTranslationPathButtonLayout id={id+"append-button"} onClick={onOpen} {...others} />
            <AutoFormDialog
                id={id+"append-dialog"}
                mode="create"
                formId={id+"append-form"}
                title={ t ( "dialog.title.TranslationPath.create" ) }
                schema={schema}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                setInitialDataCallback={setInitialDataCallback}
            />
        </>

    );
    
}

export default AddTranslationPathButton;

